import { ActionTree } from 'vuex';
import { appointmentService } from '@/_services';
import { IRootState, IModuleAppointmentState } from '../types';

export const actions: ActionTree<IModuleAppointmentState, IRootState> = {
    async getAppointmentByObjectId({ commit }, criteria) {
        commit('fetchAppointments');

        const { objectId, key } = criteria;
        return appointmentService.getAppoinmentsByObjectID({ objectId, key }).then(res => {
            commit('fetchAppointmentsSuccess', res);
            return Promise.resolve(res);
        }).catch(err => {
            return Promise.reject(err);
        });
    },

    async getProperty({ commit }, criteria) {
        commit('fetchProperty');

        const { objectId, key } = criteria;
        return appointmentService.getProperty({ objectId, key }).then(res => {
            commit('fetchPropertySuccess', res);
            return Promise.resolve(res);
        }).catch(err => {
            return Promise.reject(err);
        });
    },

    syncAppointmentClick({ commit }, criteria) {
        commit('syncAppointmentClick', criteria);
    },

    sendContactAppointment({ commit }, payload) {
        commit('sendContact');
        const { objectId, key, data, email } = payload;
        return new Promise(function (resolve, reject) {
            appointmentService.sendContactAppointment({ objectId, key, data, email })
                .then((res) => {
                    commit('sendContactSuccess', res);
                    resolve('Send Contact Success !!!');
                })
                .catch((err) => {
                    console.log(err);
                    commit('sendContactSuccess', err);
                    reject('Send Contact fail !!!');
                });
        });


    }
};
